import { render, staticRenderFns } from "./TenantsList.vue?vue&type=template&id=5a47bbf8&"
import script from "./TenantsList.vue?vue&type=script&lang=js&"
export * from "./TenantsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports